import { AuthService } from '../auth/AuthService';
import { ApiBack } from '../axios-config';


const getPDF = async (uuid: string): Promise<any | Error> => {

	await AuthService.verify();

	try {
		const token = await AuthService.getAccessToken();

		const response = await ApiBack.get(`/risrot/download?uuid=${uuid}`, {
			headers: {
				Authorization: `${token}`
			},
			responseType: 'blob',
		});

		if (response.data) {
			return response;
		}

		return new Error('Erro ao buscar plantas');
	} catch (error) {
		console.log(error);
		return new Error((error as { message: string }).message || 'Erro ao buscar plantas');
	}
};

const list = async (uuid: string): Promise<any | Error> => {

		await AuthService.verify();

		try{
				const token = await AuthService.getAccessToken();

				const response = await ApiBack.get(`./risrots?uuid=${uuid}`, {
						headers: {
								Authorization: `${token}`
						}
				});        

				if(response.data){
						return response.data;
				}

				return new Error('Erro ao buscar dados', response.data);
		} catch (error: any) {
				if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
						return new Error(error.response.data.message);
				} else {
						return new Error((error as { message: string }).message || 'Erro ao buscar dados', error);
				}
		}
};

const create = async (data: any, uuid: string): Promise<any | Error> => {

		await AuthService.verify();

		try{
				const token = await AuthService.getAccessToken();

				const response = await ApiBack.post(`./risrot?uuid=${uuid}`, data, {
						headers: {
								Authorization: `${token}`
						}
				});

				if(response.data){
						return response.data;
				}

				return new Error('Erro ao buscar dados', response.data);

		}catch (error: any) {
				if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
						return new Error(error.response.data.message);
				} else {
						return new Error((error as { message: string }).message || 'Erro ao buscar dados', error);
				}
		}

};

const upgrade = async (data: any, uuid: string): Promise<any | Error> => {

		await AuthService.verify();

		try{
				const token = await AuthService.getAccessToken();

				const response = await ApiBack.put(`./risrot?uuid=${uuid}`, data, {
						headers: {
								Authorization: `${token}`
						}
				});

				if(response.data){
						return response.data;
				}

				return new Error('Erro ao buscar dados', response.data);

		}catch (error: any) {
				if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
						return new Error(error.response.data.message);
				} else {
						return new Error((error as { message: string }).message || 'Erro ao buscar dados', error);
				}
		}

};

const getCabecalho = async (uuid: string, data: string, hora_inicio: string, hora_fim: string): Promise<any | Error> => {

		await AuthService.verify();

		try{
				const token = await AuthService.getAccessToken();

				const response = await ApiBack.get(`./risrot/cabecalho?uuid=${uuid}&data=${data}&hora_inicio=${hora_inicio}&hora_fim=${hora_fim}`, {
						headers: {
								Authorization: `${token}`
						}
				});        

				if(response.data){
						return response.data;
				}

				return new Error('Erro ao buscar dados', response.data);
		} catch (error: any) {
				if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
						return new Error(error.response.data.message);
				} else {
						return new Error((error as { message: string }).message || 'Erro ao buscar dados', error);
				}
		}
};

const get = async (uuid: string): Promise<any | Error> => {

		await AuthService.verify();

		try{
				const token = await AuthService.getAccessToken();

				const response = await ApiBack.get(`./risrot?uuid=${uuid}`, {
						headers: {
								Authorization: `${token}`
						}
				});        

				if(response.data){
						return response.data;
				}

				return new Error('Erro ao buscar dados', response.data);
		} catch (error: any) {
				if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
						return new Error(error.response.data.message);
				} else {
						return new Error((error as { message: string }).message || 'Erro ao buscar dados', error);
				}
		}
};

const delet = async (uuid: string): Promise<any | Error> => {

		await AuthService.verify();

		try{
				const token = await AuthService.getAccessToken();

				const response = await ApiBack.delete(`./risrot?uuid=${uuid}`, {
						headers: {
								Authorization: `${token}`
						}
				});        

				if(response.data){
						return response.data;
				}

				return new Error('Erro ao buscar dados', response.data);
		} catch (error: any) {
				if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
						return new Error(error.response.data.message);
				} else {
						return new Error((error as { message: string }).message || 'Erro ao buscar dados', error);
				}
		}
};


export const ServicesRisrot = {
	getPDF,
	list,
	create,
	get,
	upgrade,
	delet,
	getCabecalho
};